import { render, staticRenderFns } from "./Section_List.vue?vue&type=template&id=416d613c&scoped=true&"
import script from "./Section_List.vue?vue&type=script&lang=js&"
export * from "./Section_List.vue?vue&type=script&lang=js&"
import style0 from "./Section_List.vue?vue&type=style&index=0&id=416d613c&scoped=true&lang=css&"
import style1 from "./Section_List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d613c",
  null
  
)

export default component.exports